import { render, staticRenderFns } from "./InputForm.vue?vue&type=template&id=6ebbc59a&scoped=true&lang=pug&"
import script from "./InputForm.vue?vue&type=script&lang=js&"
export * from "./InputForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebbc59a",
  null
  
)

export default component.exports